<template>
  <remaining-tasks-list :title="title" :tasks="tasks" />
</template>

<script>
import RemainingTasksList from './RemainingTasksList';
import { ScreeningProgressSummary } from '@/models';

export default {
  name: 'ScreeningRemainingTasksList',
  components: { RemainingTasksList },
  props: {
    progressSummary: {
      type: ScreeningProgressSummary,
      required: true,
    },
    title: {
      type: String,
      default: 'Remaining Screening Tasks',
    },
    voteTaskLabel: {
      type: String,
      default: 'References you can vote on',
    },
    conflictTaskLabel: {
      type: String,
      default: 'Conflicts to resolve',
    },
  },
  computed: {
    tasks() {
      const tasks = [];
      if (this.remainingCanVoteOn > 0) {
        tasks.push({
          key: 'votes',
          text: this.voteTaskLabel,
          count: this.remainingCanVoteOn,
        });
      }
      if (this.conflicts > 0) {
        tasks.push({
          key: 'conflicts',
          text: this.conflictTaskLabel,
          count: this.conflicts,
        });
      }

      return tasks;
    },
    conflicts() {
      return this.progressSummary?.conflictedScreenCount ?? 0;
    },
    remainingCanVoteOn() {
      return this.progressSummary?.remainingUserCanVoteOnCount() ?? 0;
    },
  },
};
</script>
